import * as common from '@/store/common/mutation-types';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const STATE_APCN_INIT = 'STATE_APCN_INIT';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const PAGING_INFO = 'PAGING_INFO';
export const RO_APCN_INFO = 'RO_APCN_INFO';
export const RO_APCN_SAVE_INFO = 'RO_APCN_SAVE_INFO';
/*******************************************얼그레이아이스티 ******************************/
//팝업 캠페인 목록
export const STATE_CMPN_MST_INIT = 'STATE_CMPN_MST_INIT';
export const STATE_CMPN_OP_CD_INIT = 'STATE_CMPN_OP_CD_INIT';
export const CMPN_MST_SEARCH_PARAMS = 'CMPN_MST_SEARCH_PARAMS';

/*******************************************얼그레이아이스티 ******************************/
export default {
	...common,
	SEARCH_PARAM,
	STATE_INIT,
	STATE_APCN_INIT,
	DEFAULT_ASSIGN,
	PAGING_INFO,
	RO_APCN_INFO,
	RO_APCN_SAVE_INFO,

	/*******************************************얼그레이아이스티 ******************************/
	//팝업 캠페인 목록
	STATE_CMPN_MST_INIT,
	STATE_CMPN_OP_CD_INIT,
	CMPN_MST_SEARCH_PARAMS
	/*******************************************얼그레이아이스티 ******************************/
};
